/**
 * Created by hp on 2017/6/26.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Mask, Button, Toast} from 'react-weui';
import Config from '../../config';
import {isLZWKAPP} from '../../utils'
import { wxPay, goBack } from '../../utils/connectApp'
import ChannelDiscountPanel from './ChannelDiscountPanel';
import ChannelMonthPanel from './ChannelMonthPanel';

import '../../styles/channel/ChannelPayPanel.css';
import { setEvent } from '../../services';

class ChannelPayPanel extends Component {
    constructor() {
        super();
        this.onRequestClose = this.onRequestClose.bind(this);
        this.handlePay = this.handlePay.bind(this);
        this.state = {
            isShowSuccessToast: false
        }
    }

    componentDidMount() {
        if (this.props.newCoupon.couponData){
            this.props.dispatch({
                type: 'CHANNEL_SET_DISCOUNT',
                payload: this.props.newCoupon.couponData
            })
        }
    }

    onRequestClose() {
        this.props.dispatch({
            type: 'CHANNEL_HIDE_PAY_PANEL'
        });
    }


    handlePay() {
        const {channelId, priceRecordId, discount, meta} = this.props;
        let params = {};

        if (isLZWKAPP()) {
            window.payResult = (data) => {
                if (data.code === -1) {
                    return alert('支付失败')
                }
                if (data.code === 0) {
                    this.showSuccessToast();
                    setTimeout(() => {
                        goBack()
                    }, 1000)
                }
            }
            let payParams = {}
            if (this.props.location.query.st) {
                payParams = { ...payParams, st: this.props.location.query.st }
            }
            if (this.props.location.query.inviter_id) {
                payParams = { ...payParams, inviter_id: this.props.location.query.inviter_id }
            } else {
                payParams = { ...payParams, inviter_id: '44318813' }
            }
            payParams = {...payParams, discount_code: this.props.discount.code,  discount_id: this.props.discount.id};
            wxPay({
                id: channelId,
                product: 'pay_channel',
                productField: 'channel_id',
                type: 'channel',
                payParams,
            });
            return
        }

        if (priceRecordId > 0) {
            params = {
                product: 'pay_channel',
                channel_id: channelId,
                price_record_id: priceRecordId,
            };
        } else {
            params = {
                product: 'pay_channel',
                channel_id: channelId
            }
        }

        if (discount && discount.price) {
            params.discount_code = discount.code;
            params.discount_id = discount.id;
            setEvent({name: 'wk_channel-pay-discount-panel'})
        } else {
            setEvent({name: 'wk_channel-pay-normal'})
        }
        this.props.dispatch({
            type: 'PAY_CHANNEL',
            payload: {
                params: Object.assign(params, {platform: meta.platform, user_sign: meta.user_sign}),
                success: () => {
                    window.location = Config.MAIN_URL + `/channel/${channelId}/paysuccess${location.search}`;
                }
            }
        })
    }

    showSuccessToast () {
        this.setState({ isShowSuccessToast: true });
        setTimeout(() => {
            this.setState({ isShowSuccessToast: false })
        }, 1000)
    }

    render() {
        const {discount, isCostFix, newCoupon} = this.props;
        return (
            <div className="channel-pay-panel">
                <Toast icon="success-no-circle" show={this.state.isShowSuccessToast}>购买成功</Toast>
                <Mask onClick={this.onRequestClose}/>
                <div className={`channel-pay-panel-container`}>
                    {((discount && discount.price) || (newCoupon.hasCoupon && newCoupon.canUseCouponBuy)) &&
                    <ChannelDiscountPanel />
                    }
                    {!isCostFix &&
                    <ChannelMonthPanel />
                    }
                    <div className="channel-pay-channel">
                        <Button onClick={this.handlePay}>下一步</Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    discount: state.channel.discount,
    channelId: state.channel.channel.id,
    isCostFix: state.channel.channel.is_cost_fix,
    priceRecordId: state.channel.priceRecordId,
    newCoupon: state.newCoupon,
    meta: state.channel.meta,
}))(ChannelPayPanel)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelPayPanel.js